<div class="cm-slide-toggle" (click)="$toggle.set(!$toggle()); toggleChange.emit($toggle())" [class.cm-disabled]="$disabled()">
    @if ($toggle()) {
        <i class="fa-solid fa-toggle-on"></i>
    } @else {
        <i class="fa-solid fa-toggle-off" [class.cm-no-value]="$toggle() === undefined || $toggle() === null"></i>
    }
    <ng-content select="[cm-text]"> </ng-content>
</div>
